import { createSlice } from "@reduxjs/toolkit";
import { consumerPurchaseManageApiSlice } from "./consumerPurchaseManageApiSlice";

export const initialState = {
    query: {},
    // selectedProductDetails: {
    //     productDetails: {},
    //     schemeDetails: {},
    //     one: {
    //         variant_id: {},
    //     },
    //     variantTest: {},
    //     availableVariantsKeys: {},
    //     is_available_to_buy: false,
    // },
    one: {},
    selectedProduct: {

    },
    registerData: {
        province: '',
        district: '',
        area: '',
        retail: ''
    },
    //   officeOptions: [],
    //   openOrderSucc: false,
    //   orderConfirmedData: {},
    //   districtOptions: [],
    //   vdcsOptions: [],
    sliderData: {},
    stateLocation: [],
    districtLocation: [],
    vdcLocation: [],
    officeByType: [],
    paymentMethod: {},
    bankList: []
};

const homepageSlice = createSlice({
    name: "consumerPurchaseManage",
    initialState,
    reducers: {
        setQueryValue: (state, action) => {
            if (action.payload.key) {
                state.query[action.payload.key] = action.payload.value;
            } else {
                state.query = action.payload;
            }
        },
        setOneValue: (state, action) => {
            const { key, value, productType } = action.payload;

            if (productType) {
                if (!state.one[productType]) {
                    state.one[productType] = {};
                }
                state.one[productType][key] = value;
            } else {
                state.one[key] = value;
            }
        },
        setSelectedProductValue: (state, action) => {
            state.selectedProduct = action.payload.value;
        },
        setRegisterValue: (state, action) => {
            state.registerData[action.payload.key] = action.payload.value;
        },
        clearOne: (state, action) => {
            state.one = initialState.one;
        },
        clearRegisterData: (state, action) => {
            state.registerData = initialState.registerData;
        },
        // setSelectedProduct: (state, { payload }) => {
        //   state.selectedProductDetails.productDetails = payload;
        //   if (payload?.is_multiple_variation) {
        //     state.selectedProductDetails.variantTest =
        //       payload.inventory_type?.reduce(
        //         (acc, curr) => ({
        //           ...acc,
        //           [curr.inventory_type]: curr.option[0],
        //         }),
        //         {}
        //       ) || {};
        //   }
        //   state.selectedProductDetails.schemeDetails = {};
        //   const reqVariantObj = payload?.variant?.[0];
        //   state.selectedProductDetails.one.variant_id = reqVariantObj;

        //   // check if the product is valid to buy
        //   if (reqVariantObj?.is_available) {
        //     if (reqVariantObj?.inventory <= 0) {
        //       state.selectedProductDetails.is_available_to_buy = false;
        //     } else {
        //       state.selectedProductDetails.is_available_to_buy = true;
        //     }
        //   } else {
        //     state.selectedProductDetails.is_available_to_buy = false;
        //   }
        // },
        // setSelectedScheme: (state, { payload }) => {
        //   state.selectedProductDetails.schemeDetails = payload;
        // },
        // setCustomerValues: (state, { payload }) => {
        //   state.selectedProductDetails.customerDetails[payload.key] = payload.value;
        // },
        // setSelectVarirant: (state, { payload }) => {
        //   state.selectedProductDetails.variantTest[payload.inventory_type] =
        //     payload.inventory_value;
        //   let newVariantTestObj = {
        //     ...state.selectedProductDetails.variantTest,
        //     [payload.inventory_type]: payload.inventory_value,
        //   };
        //   let requiredSku = Object.values(newVariantTestObj).join("-");
        //   const reqVariantObj =
        //     state.selectedProductDetails.productDetails?.variant?.find(
        //       (x) => x.sku_of_seller === requiredSku
        //     );
        //   state.selectedProductDetails.one.variant_id = reqVariantObj;
        //   // check if the product is valid to buy
        //   if (reqVariantObj?.is_available) {
        //     if (reqVariantObj?.inventory <= 0) {
        //       state.selectedProductDetails.is_available_to_buy = false;
        //     } else {
        //       state.selectedProductDetails.is_available_to_buy = true;
        //     }
        //   } else {
        //     state.selectedProductDetails.is_available_to_buy = false;
        //   }
        // },
        // setOpenOrderSucc: (state, { payload }) => {
        //   state.openOrderSucc = payload;
        // },
        // setOrderConfimredData: (state, { payload }) => {
        //   state.orderConfirmedData = payload;
        // },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                consumerPurchaseManageApiSlice.endpoints.loadSliderSection.matchFulfilled,
                (state, { payload }) => {
                    state.sliderData = payload.data
                }
            )
            .addMatcher(
                consumerPurchaseManageApiSlice.endpoints.loadProductsAvailableSchemePublic.matchFulfilled,
                (state, { payload }) => {
                    state.paymentMethod = payload.msg
                }
            )
            .addMatcher(
                consumerPurchaseManageApiSlice.endpoints.loadStateLocation.matchFulfilled,
                (state, { payload }) => {
                    state.stateLocation = payload.data;
                }
            )

            .addMatcher(
                consumerPurchaseManageApiSlice.endpoints.loadDistrictLocation.matchFulfilled,
                (state, { payload }) => {
                    console.log("payload", payload)
                    state.districtLocation = payload.data;
                }
            )
            .addMatcher(
                consumerPurchaseManageApiSlice.endpoints.loadVdcLocation.matchFulfilled,
                (state, { payload }) => {
                    state.vdcOptions = payload.data;
                    state.vdcLocation = payload.data;
                }
            )
            .addMatcher(
                consumerPurchaseManageApiSlice.endpoints.loadAllOfficeByType.matchFulfilled,
                (state, { payload }) => {
                    state.officeByType = payload.data
                }
            )
            .addMatcher(
                consumerPurchaseManageApiSlice.endpoints.loadBankList.matchFulfilled,
                (state, { payload }) => {
                    state.bankList = payload.data
                }
            )
    },
});

export const {
    setQueryValue,
    setOneValue,
    clearOne,
    setRegisterValue,
    clearRegisterData,
    setSelectedProductValue,
    // setCustomerValues,
    // setSelectedProduct,
    // setSelectedScheme,
    // setSelectVarirant,
    // setOpenOrderSucc,
    // setOrderConfimredData,
} = homepageSlice.actions;

export default homepageSlice.reducer;
